import axios from "axios";
import { Message } from "element-ui";

const request = axios.create({
  baseURL: "/platform-yz",
  // baseURL: "/prevention",
});
const CryptoJS = require("crypto-js"); //引用AES源码js
const key = CryptoJS.enc.Utf8.parse("iU2zQXcUlU0cfeTr"); //十六位十六进制数作为密钥// 可以让数据块为128位

//解密方法
function Decrypt(word) {
  let encryptedHexStr = CryptoJS.enc.Hex.parse(word);
  let srcs = CryptoJS.enc.Base64.stringify(encryptedHexStr);
  let decrypt = CryptoJS.AES.decrypt(srcs, key, {
    mode: CryptoJS.mode.ECB, // 设置模式
    padding: CryptoJS.pad.Pkcs7, //// 设置填充
  });
  let decryptedStr = decrypt.toString(CryptoJS.enc.Utf8);
  return decryptedStr;
}
//生成请求标识
function getRequestKey(config, isResponse = false) {
  let requestKey = "";
  if (isResponse) {
    try {
      requestKey =
        config.url +
        (config.data ? JSON.stringify(JSON.parse(config.data)) : "");
    } catch (error) {
      requestKey = config.url + JSON.stringify(config.data);
    }
    requestKey += config.params ? JSON.stringify(config.params) : "";
  } else {
    requestKey =
      config.url +
      (config.data ? JSON.stringify(config.data) : "") +
      (config.params ? JSON.stringify(config.params) : "");
  }
  return requestKey;
}
//请求中的请求列表，用于手动取消请求
window.axiosCancel = [];

//请求拦截
request.interceptors.request.use((config) => {
  // 保存取消请求方法
  config.cancelToken = new axios.CancelToken((cancel) => {
    const requestKey = getRequestKey(config);
    window.axiosCancel.push({ key: requestKey, cancel });
  });
  return config;
});

//响应拦截
request.interceptors.response.use(
  (res) => {
    let requestKey = getRequestKey(res.config, true);
    //清空请求中列表
    const requestIndex = window.axiosCancel.findIndex((item) => {
      return item.key == requestKey;
    });
    if (requestIndex != -1) {
      window.axiosCancel.splice(requestIndex, 1);
    }
    // 数据解密
    if (res.headers.encrypt == "on") {
      res.data = JSON.parse(Decrypt(res.data.toString()));
    }
    //正常状态码200情况下
    if (res.data.code === "108") {
      // cancel.map((item) => {
      //   item && res.cancelToken != item && item(); //逐个取消请求
      // });
      //108用户未登录清除token返回登录页
      localStorage.removeItem("poor_prevent_userName");
      localStorage.removeItem("isLogin");
      localStorage.removeItem("divisionData");
      window.location.href = "#/login";
    }

    // else if (res.data.code !== "108" && res.data.code !== "00") {
    //   Message({
    //     showClose: true,
    //     type: "error",
    //     message: `${res.data.message}：${res.data.detail}`,
    //   });
    // }

    return res;
  },
  (err) => {
    //手动取消请求
    if (err.code == "ERR_CANCELED") {
      return Promise.reject("请求终止");
    }
    //错误状态码情况下
    if (err && err.response && err.response.status) {
      switch (err.response.status) {
        case 500:
          // do something...
          break;
        case 404:
          // do something...
          break;
        default:
          // do something...
          break;
      }
    } else {
      Message({
        showClose: true,
        type: "error",
        message: err,
      });
    }
  }
);

export default request;
